import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserListModel} from '../models/user-list-model';

@Component({
  selector: 'user-list',
  template: `
    <div class="row button-row">
      <div class="col-md-12 text-right">
        <a routerLink="editor"><i class="fa fa-plus"></i> Add New User</a>
      </div>
    </div>
    <div class="row header">
        <div class="col-md-2">User Name</div>
        <div class="col-md-3">Name</div>
        <div class="col-md-2">Role</div>
        <div class="col-md-1">Enabled</div>
        <div class="col-md-3">&nbsp;</div>
    </div>
    <div class="row line-item" [ngClass]="{'red': !u.enabled}" *ngFor="let u of results">
      <div class="col-md-2">{{u.username}}</div>
      <div class="col-md-3">{{u.firstname}} {{u.lastname}}</div>
      <div class="col-md-2">{{u.role}}</div>
      <div class="col-md-1 text-center"><input type="checkbox" disabled [ngModel]="u.enabled"/></div>
      <div class="col-md-4 text-right">
        <a [routerLink]="['editor', u.username]"><i class="fa fa-pencil"></i> Edit</a>
        <a class="action-link" (click)="aliasUser.emit(u.username)"><i class="fa fa-user-secret"></i> Alias</a>
        <a class="action-link" (click)="resetPassword.emit(u.username)"><i class="fa fa-repeat"></i> Reset Password</a>
        <a class="action-link" (click)="toggleEnabled.emit(u.id)">
          <span *ngIf="u.enabled"><i class="fa fa-lock"></i> Disable</span>
          <span *ngIf="!u.enabled"><i class="fa fa-unlock"></i> Enable</span>          
        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
        <a class="action-link" (click)="registerMfa.emit(u.username)">Register MFA</a>
      </div>
    </div>
  `,
  styles: [`
    .header {
      margin-bottom: 5px;
      border-bottom: 1px solid #666;
      font-weight:bold;
    }
    .line-item {
      border-bottom: 1px solid #ccc;
      margin-bottom:3px;
      padding-bottom:3px;
    }
    .button-row {
      margin-bottom:10px;
    }
    .action-link {
      margin-left:20px;
    }
    .red {
      color: red!important;
    }
  `]
})
export class UserListComponent {

  @Input() results: UserListModel[];
  @Output() aliasUser: EventEmitter<number> = new EventEmitter();
  @Output() resetPassword: EventEmitter<number> = new EventEmitter();
  @Output() toggleEnabled: EventEmitter<number> = new EventEmitter();
  @Output() registerMfa: EventEmitter<string> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/user-list.ts